module.exports = __webpack_public_path__ + "static/chinareisen-bb50425a53264344d07c70ee23421b89.svg";